import React, { useState } from 'react';

import { IStorytellingFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';

import { Box } from '../Box';
import RichText from '../RichText';
import { Collapsible } from '../Collapsible';
import { BlockContainer, Layout, Column } from '../Layout';

import {
  ImageWrapper,
  StyledImage,
  StoryColumn,
  StoryBox,
  MaxWidthHeading,
  StorytellingButton
} from './styles';

interface Props extends IStorytellingFields {
  sysId?: string;
}

export function Storytelling({
  headingText,
  image,
  collapsibles,
  button,
  images,
  sysId,
  anchorLink
}: Props) {
  const [currentImageIndex, setCurrentImageIndex] = useState(-1);

  const toggleCollapsible = (index: number) => {
    if (currentImageIndex === index) {
      setCurrentImageIndex(-1);
    } else {
      setCurrentImageIndex(index);
    }
  };

  return (
    <BlockContainer
      marginTop={{ 0: 'blockMarginY', desktop: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', desktop: 'blockMarginY_tablet' }}
      data-blockid="storytelling"
      data-testid="storytelling"
      id={anchorLink ?? `storytelling-${sysId}`}
    >
      <Layout
        flexWrap="wrap"
        alignItems="flex-start"
        gutter={{ 0: 's', tablet: 'xl' }}
      >
        <Column size={{ 0: 12, tablet: 6, desktop: 5 }}>
          <ImageWrapper>
            <StyledImage
              {...getImageData(image)}
              currentImage={images ? currentImageIndex === -1 : true}
            />
          </ImageWrapper>
          {images &&
            images.map((img, index: number) => (
              <ImageWrapper key={index}>
                <StyledImage
                  {...getImageData(img)}
                  currentImage={currentImageIndex === index}
                />
              </ImageWrapper>
            ))}
        </Column>
        <StoryColumn size={{ 0: 10, tablet: 6, desktop: 4 }}>
          <StoryBox>
            <Box paddingBottom="l">
              <MaxWidthHeading
                as="h2"
                fontSize={{ 0: 'h2_0', tablet: 'xl', desktop: 'h2_desktop' }}
                fontWeight="h2"
              >
                {headingText}
              </MaxWidthHeading>
            </Box>
            <Box margin={{ 0: [0, 0, 'xl', 0] }}>
              {collapsibles &&
                collapsibles.map(({ fields }, index: number) => {
                  return (
                    fields && (
                      <Collapsible
                        {...fields}
                        key={index}
                        isOpen={currentImageIndex === index}
                        onClick={() => toggleCollapsible(index)}
                      />
                    )
                  );
                })}
            </Box>
            {button && (
              <StorytellingButton>
                <RichText data={button} />
              </StorytellingButton>
            )}
          </StoryBox>
        </StoryColumn>
      </Layout>
    </BlockContainer>
  );
}
